import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const sandboxRelayEchoPageUsingRLLRoute: InvariantJiraRoute = {
	name: 'sandbox-relay-defer-echo',
	path: '/jira/software/sandbox/relay/echo',
	exact: true,
};
